import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Breadcrumbs from './../block/Breadcrumbs'
import AboutCompanyPage from './../block/AboutCompanyPage'
import WhyTrustUsSection from './../block/WhyTrustUsSection'
import PartnersSlyder from './../block/PartnersSlyder'
import FAQSection from './../block/FAQSection'

export default class AboutCompany extends Component {

  render() {

    const { data, ajax_data, user_profile_type } = this.props

    return (
      <>
        <Breadcrumbs items={ajax_data.breadcrumbs} />
        <AboutCompanyPage
          text={user_profile_type == `legal` ? ( ajax_data?.text_legal || '' ) : ( ajax_data?.content || '' )}
          text2={user_profile_type == `legal` ? ( ajax_data?.text2_legal || '' ) : ( ajax_data?.text2 || '' )}
        />
        <WhyTrustUsSection
          page_data={data?.page_data || {}}
          user_profile_type={user_profile_type}
        />
        {user_profile_type == `individual` &&
          <PartnersSlyder
            list={ajax_data?.partners || []}
          />
        }
        <FAQSection
          qwestions={user_profile_type == `legal` ? ( ajax_data?.qwestions_ng_legal || [] ) : ( ajax_data?.qwestions_ng || [] )}
        />
      </>
    )
  }
}

AboutCompany.propTypes = {
  data: PropTypes.object,
  ajax_data: PropTypes.object,
  user_profile_type: PropTypes.string
}